<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { RouterView } from 'vue-router'
import { Toaster } from '@/components/ui/sonner'

// Jaga-jaga: Reka UI kadang meninggalkan pointer-events: none di <body>
// saat dialog/sheet/menu tertutup atau transisi animasi terganggu.
onMounted(() => {
  const observer = new MutationObserver(() => {
    if (document.body.style.pointerEvents === 'none') {
      const hasOpenModal = document.querySelector(
        '[role="dialog"][data-state="open"], [role="alertdialog"][data-state="open"], [data-state="open"][data-side]',
      )
      if (!hasOpenModal) {
        document.body.style.removeProperty('pointer-events')
      }
    }
  })

  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['style'],
  })

  onUnmounted(() => observer.disconnect())
})
</script>

<template>
  <RouterView />
  <Toaster rich-colors position="top-right" />
</template>
